<template>
	<article class="gb-article home-article-wrap">
		<p>
			Download the <strong>latest GB WhatsApp APK</strong> v18.80 for Android with new privacy options,
			customization tools, improved performance, and enhanced messaging features. GB Apps provides the latest
			version, previous releases, installation guides, update tutorials, and solutions for common issues.
		</p>
		<p>
			Whether you are trying
			<a class="jump-url" href="https://gbappss.co/"><strong>GBWhatsApp</strong></a>
			for the first time or upgrading from an older version, you can find the right APK and helpful guides to make
			the process easier.
		</p>

		<hh2>GB WhatsApp APK v18.80</hh2>
		<p>Latest Stable Version</p>
		<div class="version-box">
			<p><strong>Version:</strong> v18.80</p>
			<p><strong>Size:</strong> 95 MB</p>
			<p><strong>Android:</strong> 5.0+</p>
			<p><strong>Updated:</strong> July 2026</p>
		</div>

		<hh2>Key Information</hh2>
		<div class="info-list">
			<p>✓ APK scanned with VirusTotal</p>
			<p>✓ Latest GB WhatsApp v18.80 Release</p>
			<p>✓ Works on Android 5.0 and Above</p>
			<p>✓ Updated Privacy &amp; Customization Features</p>
			<p>✓ Old Versions Available</p>
			<p>✓ Installation and Update Guides</p>
		</div>

		<hh2>What Is GB WhatsApp?</hh2>
		<p>
			GB WhatsApp is a popular WhatsApp MOD that adds extra features and customization options beyond the official
			app. It allows users to enjoy more privacy controls, custom themes, larger file sharing, status downloads,
			and additional chat tools.
		</p>
		<p>
			Many users choose GBWhatsApp because they want more control over their messaging experience, such as hiding
			online status, changing the app design, or using features like auto reply and message scheduling.
		</p>
		<p>
			GB WhatsApp is a third-party modified app and is not officially supported by Meta. Users should download it
			from <strong>trusted sources</strong> and back up important chats before installing or updating.
		</p>

		<hh2>What's New in the Latest GBWhatsApp Version 2026?</hh2>
		<p>
			The latest
			<a class="jump-url" href="https://gbappss.co/">GB WhatsApp APK</a>
			version brings new improvements, privacy options, and useful tools that make everyday messaging more
			flexible. Besides the standard chat features, users can enjoy more control over privacy, appearance, and
			communication settings.
		</p>

		<hh3>Improved Privacy Controls</hh3>
		<p>
			New privacy options give users more control over their online activity. Features like Ghost Mode allow you
			to hide online status, disable read receipts, and view statuses more privately.
		</p>

		<hh3>Do Not Disturb Mode</hh3>
		<p>
			Do Not Disturb mode works like a simple offline switch for GBWhatsApp. It blocks the app's internet
			connection, allowing you to pause incoming messages without turning off your phone's entire network.
		</p>

		<hh3>More Customization Options</hh3>
		<p>
			GBWhatsApp 2026 adds more ways to personalize your app experience. Users can apply themes, change interface
			styles, customize animations, and adjust the home screen appearance.
		</p>

		<hh3>Extra Messaging Tools</hh3>
		<p>The latest update also includes useful tools that are not available in the official WhatsApp app, such as:</p>
		<ul>
			<li>Auto Reply</li>
			<li>Message Scheduler</li>
			<li>Status Downloader</li>
			<li>Advanced file sharing</li>
			<li>Chat management tools</li>
		</ul>
		<p>
			With these updates, GB WhatsApp continues to focus on giving users more control over privacy, customization,
			and daily communication.
		</p>

		<hh2>How to Download GB WhatsApp APK 2026</hh2>
		<p>
			Downloading the latest GB WhatsApp APK is simple. If you want to install the updated version on your Android
			device, follow these steps:
		</p>
		<p>
			Before saving the file, you can compare a current
			<a class="jump-url" href="https://gbdwnpro.org/">GB WhatsApp APK Download</a>
			page so the build matches your device.
		</p>
		<ol>
			<li>
				Click the
				<a class="jump-url" href="/download/"><strong>Download GB WhatsApp</strong></a>
				button on this page.
			</li>
			<li>On the download page, tap the download button to get the latest GB WhatsApp APK file.</li>
			<li>
				Once the download is complete, open the APK file from your phone’s <strong>Downloads</strong> folder and
				start the installation.
			</li>
		</ol>
		<p>
			Before installing, make sure you have enabled APK installation permissions on your Android device. If you
			are updating from an older version, creating a backup first is recommended to keep your chats and media
			safe.
		</p>
		<p>After installation, open GBWhatsApp, verify your phone number, and restore your backup if needed.</p>

		<hh2>How to Install GBWhatsApp 2026 on Android</hh2>
		<p>
			Installing GB WhatsApp APK is similar to installing any other Android application. Follow these simple steps
			to get started:
		</p>
		<ol>
			<li>Download the latest GBWhatsApp APK file from the download page.</li>
			<li>Open the APK file from your phone’s Downloads folder or file manager.</li>
			<li>Tap <strong>Install</strong> and wait for the installation process to complete.</li>
			<li>Open GB WhatsApp and enter your phone number to set up your account.</li>
			<li>Restore your chat backup if you have one, then start using the app.</li>
		</ol>
		<p>
			After installation, the interface will look familiar to WhatsApp, but you will find additional settings and
			customization options inside the GBWhatsApp menu.
		</p>
		<p>
			If Android blocks the installation, make sure you allow your browser or file manager to install apps from
			unknown sources in your device settings.
		</p>

		<hh2>GB WhatsApp 2026 Features &amp; Functions</hh2>
		<p>
			GB WhatsApp adds extra tools and customization options that are not available in the standard WhatsApp app.
			Many users choose it because they want more control over privacy, chat settings, appearance, and everyday
			messaging.
		</p>
		<p>
			From hiding online activity to customizing the interface, GB WhatsApp provides additional features designed
			for users who want a more flexible messaging experience.
		</p>
		<img class="content-img" :src="imgAndroid" alt="GB WhatsApp Android features overview" loading="lazy" />

		<hh3>Advanced Privacy Features</hh3>
		<p>
			Privacy is one of the main reasons users try GB WhatsApp. The app provides more options to control what
			others can see when you are using WhatsApp.
		</p>

		<h4>Ghost Mode</h4>
		<p>
			Ghost Mode helps you stay more private while chatting. You can hide your online activity, prevent read
			receipts, and view statuses without notifying other users.
		</p>

		<h4>Hide Online Status &amp; Last Seen</h4>
		<p>
			Control your visibility by hiding your online status or freezing your last seen time. This allows you to use
			WhatsApp without feeling pressured to reply immediately.
		</p>

		<h4>Hide Blue Ticks and Typing Status</h4>
		<p>
			GB WhatsApp allows you to hide blue ticks, second ticks, typing indicators, and recording status. Your
			contacts will not know when you have read messages or are preparing a reply.
		</p>

		<h4>App Lock</h4>
		<p>
			Protect your conversations with an additional app lock. You can secure GB WhatsApp with a password, PIN, or
			other available security options to keep your chats private.
		</p>

		<h4>Anti-Delete Messages</h4>
		<p>
			The anti-delete feature allows users to keep viewing messages that were removed by the sender. This can be
			useful when important information is deleted accidentally.
		</p>
		<img class="content-img" :src="imgPrivacy" alt="GB WhatsApp advanced privacy features" loading="lazy" />

		<hh3>Messaging &amp; Productivity Tools</hh3>
		<p>Besides privacy options, GB WhatsApp includes several tools that make daily communication easier.</p>

		<h4>Auto Reply</h4>
		<p>
			Auto Reply allows you to send automatic responses when you are unavailable. This feature can be useful for
			business accounts or users who receive messages frequently.
		</p>

		<h4>Message Scheduler</h4>
		<p>
			Schedule messages to be sent at a specific time. Whether it is a birthday reminder, work message, or
			important notification, you can prepare messages in advance.
		</p>

		<h4>Send Messages Without Saving Numbers</h4>
		<p>
			Chat with a phone number directly without adding it to your contact list first. This is useful when you only
			need to send a quick message.
		</p>

		<h4>Do Not Disturb Mode</h4>
		<p>
			Do Not Disturb mode works like a temporary offline option for GB WhatsApp. It blocks the app's internet
			connection while allowing other apps on your phone to continue working normally.
		</p>

		<h4>Status Downloader</h4>
		<p>
			Save photos and videos from WhatsApp Status updates directly to your device without asking contacts to
			resend the files.
		</p>

		<hh2>Customization Features</hh2>
		<p>
			One of the biggest differences between GBWhatsApp and the official app is the level of customization
			available.
		</p>

		<h4>Custom Themes</h4>
		<p>
			Choose from different themes and styles to change the appearance of your WhatsApp interface. You can create
			a design that matches your personal preference.
		</p>

		<h4>Chat Customization</h4>
		<p>
			Modify chat backgrounds, message bubbles, fonts, colors, and interface layouts. You can adjust small details
			to create a more personalized messaging experience.
		</p>

		<h4>Custom Fonts and Emojis</h4>
		<p>
			Change fonts, emoji styles, and other visual elements to make conversations look different from the standard
			WhatsApp design.
		</p>

		<h4>App Icon and Interface Settings</h4>
		<p>
			Customize the app icon, home screen appearance, widgets, and other interface elements to make GB WhatsApp
			feel more unique.
		</p>

		<hh3>Media Sharing Improvements</hh3>
		<p>
			Sharing files is an important part of modern messaging, and GB WhatsApp provides additional options for
			sending media.
		</p>

		<h4>Larger File Sharing</h4>
		<p>
			Send larger videos, images, and documents with fewer restrictions compared with the standard WhatsApp
			experience.
		</p>

		<h4>HD Photos and Videos</h4>
		<p>Share higher-quality media files while reducing unnecessary compression during transfers.</p>

		<h4>More File Options</h4>
		<p>
			Send different types of files and manage your media more easily when sharing content with friends, family,
			or work contacts.
		</p>
		<img class="content-img" :src="imgChat" alt="GB WhatsApp chat and media customization" loading="lazy" />

		<hh3>Backup &amp; Account Management</hh3>
		<p>Managing your chats is important, especially when updating to a new version or changing devices.</p>

		<h4>Backup and Restore</h4>
		<p>
			Create backups of your conversations, media files, and settings before installing a new version. This helps
			reduce the risk of losing important chats.
		</p>

		<h4>Multiple Account Support</h4>
		<p>
			Some GB WhatsApp versions support using multiple accounts on the same device, making it easier to separate
			personal and business communication.
		</p>

		<hh3>Temporary File Cleaner</hh3>
		<p>Remove unnecessary temporary files and free up storage space directly from the application settings.</p>

		<hh2>Extra Tools for Daily Use</hh2>
		<p>GBWhatsApp also includes additional tools that improve the overall experience.</p>
		<ul>
			<li>Advanced notification controls</li>
			<li>Chat organization options</li>
			<li>Call management settings</li>
			<li>Additional sticker support</li>
			<li>Improved media management</li>
			<li>More control over group chats</li>
		</ul>

		<hh2>GB WhatsApp Old Versions</hh2>
		<p>
			Sometimes the latest GB WhatsApp update may not work perfectly on every Android device. Some users prefer
			older versions because of better compatibility, familiar features, or a lighter app experience.
		</p>
		<p>
			Below are some popular GB WhatsApp old versions. If you are using an older Android phone or need a previous
			release, you can check these versions before downloading.
		</p>
		<div class="gb-table-wrap">
			<table class="gb-table">
				<thead>
					<tr>
						<th>Version</th>
						<th>Release</th>
						<th>Status</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="row in homeOldVersions" :key="row.version">
						<td>{{ row.version }}</td>
						<td>{{ row.release }}</td>
						<td>{{ row.status }}</td>
					</tr>
				</tbody>
			</table>
		</div>
		<p>
			Older versions can be useful for users who have compatibility issues with newer releases. However, newer
			versions usually include bug fixes, improved compatibility, and updated features, so most users should
			choose the latest stable release whenever possible.
		</p>
		<p>
			<a class="jump-url" href="/old-versions/"><strong>View All GB WhatsApp Old Versions</strong></a>
			<strong> →</strong>
		</p>

		<hh2>GB WhatsApp for PC Windows 11/10</hh2>
		<p>
			Want to use GB WhatsApp on a bigger screen? You can run GB WhatsApp on your Windows PC using an Android
			emulator.
		</p>
		<p>
			Although GB WhatsApp does not have a native Windows version, emulator tools allow you to install the APK and
			enjoy features like custom themes, privacy controls, and advanced messaging options on your computer.
		</p>
		<p>
			Whether you use Windows 11 or Windows 10, you can follow our step-by-step guide to install GB WhatsApp on
			PC.
		</p>
		<p>
			<strong>Learn</strong>
			<a class="jump-url" href="/for-pc/"><strong> how to use GB WhatsApp on PC</strong></a>
			<strong> →</strong>
		</p>

		<hh2>GB WhatsApp vs Official WhatsApp</hh2>
		<div class="gb-table-wrap">
			<table class="gb-table">
				<thead>
					<tr>
						<th>Feature</th>
						<th>GB WhatsApp</th>
						<th>Official WhatsApp</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(row, idx) in compareOfficial" :key="idx">
						<td>{{ row.feature }}</td>
						<td>{{ row.gb }}</td>
						<td>{{ row.official }}</td>
					</tr>
				</tbody>
			</table>
		</div>

		<hh2>How to Set Up GBWhatsApp Account</hh2>
		<p>
			Setting up GB WhatsApp is similar to the official WhatsApp app. After installing the APK, you can activate
			your account by following a few simple steps.
		</p>
		<ol>
			<li>Open GB WhatsApp and choose your preferred language.</li>
			<li>Accept the terms and continue with the setup process.</li>
			<li>Enter your phone number and complete verification using the SMS code.</li>
			<li>Add your profile name and restore available backup data if you have one.</li>
		</ol>
		<p>
			Once the setup is complete, you can start using GB WhatsApp with its additional privacy and customization
			features.
		</p>

		<hh2>How to Transfer WhatsApp Chats to GB WhatsApp</hh2>
		<p>
			Moving chats from the official WhatsApp app to GB WhatsApp can be different from a normal WhatsApp backup
			restore.
		</p>
		<p>
			Since GB WhatsApp is a third-party modified app, Google Drive backup support may not work the same way as
			the official WhatsApp application.
		</p>
		<p>
			Before switching, it is recommended to create a local backup and keep a copy of important conversations and
			media files. Always check the backup compatibility of your current version before updating or changing apps.
		</p>

		<hh2>How to Update GB WhatsApp to the Latest Version</hh2>
		<p>Keeping GB WhatsApp updated helps improve compatibility, fix bugs, and access new features.</p>
		<p>There are two common ways to update:</p>

		<hh3>Download the Latest APK Version</hh3>
		<p>
			Visit a trusted GB WhatsApp download page and check whether a newer version is available. Download the
			latest APK file and install it over your current version after creating a backup.
		</p>

		<hh3>Check Update Options Inside the App</hh3>
		<p>
			Some GB WhatsApp versions include an update section in the settings menu. However, checking the latest
			available version manually is recommended because update notifications may not always be accurate.
		</p>

		<hh2>Why Is GB WhatsApp Not Working?</hh2>
		<p>
			Sometimes GB WhatsApp may stop working because of compatibility issues, incorrect settings, or
			account-related problems.
		</p>
		<p>Common causes include:</p>

		<hh3>Outdated Version</hh3>
		<p>
			Older versions may not work correctly after WhatsApp or Android updates. Installing the latest version can
			often solve these issues.
		</p>

		<hh3>App Settings Problems</hh3>
		<p>
			Changing certain options may occasionally cause unexpected errors. Clearing app data and setting up the
			account again may help restore normal operation.
		</p>

		<hh3>Account Restrictions</hh3>
		<p>
			Because GB WhatsApp is a modified application, some users may experience temporary restrictions when using
			unofficial versions.
		</p>
		<p>
			If you cannot access your account, try waiting for a period of time and check whether the issue is resolved.
			For serious account problems, contacting WhatsApp support may be necessary.
		</p>

		<hh2>GB WhatsApp Backup &amp; Restore</hh2>
		<p>
			Keeping a backup before updating or reinstalling GB WhatsApp is important, especially if you have years of
			conversations, photos, and important files stored in your chats.
		</p>
		<p>
			GB WhatsApp usually saves local backup files inside your phone storage. The backup folder location may vary
			depending on the version you use, but it is commonly found under:
		</p>
		<p><strong>Android &gt; media &gt; com.gbwhatsapp &gt; Backups</strong></p>
		<p>
			Before deleting the app or installing a new version, make sure these backup files are still saved on your
			device.
		</p>

		<hh2>How to Restore GBWhatsApp Chats</hh2>
		<p>If you have created a backup, restoring your chats is usually simple:</p>
		<ol>
			<li>Install GB WhatsApp on your Android device.</li>
			<li>Make sure the backup folder is placed in the correct location.</li>
			<li>Open GB WhatsApp and verify your phone number.</li>
			<li>Choose the restore option when the app detects available backup files.</li>
		</ol>
		<p>After restoration, your chats, media files, and some app settings may become available again.</p>

		<hh2>Can GB WhatsApp Use Google Drive Backup?</hh2>
		<p>
			Unlike the official WhatsApp application, many GB WhatsApp versions do not support Google Drive backup
			because they are third-party modified apps.
		</p>
		<p>
			For this reason, it is recommended to keep a local backup copy before updating, switching versions, or
			changing devices.
		</p>

		<hh2>GB WhatsApp Pros and Cons</hh2>
		<div class="pros-cons">
			<div class="box">
				<hh3>Advantages</hh3>
				<p>✓ More customization options</p>
				<p>✓ Advanced privacy controls</p>
				<p>✓ Extra messaging tools</p>
				<p>✓ Support for multiple accounts on some versions</p>
				<p>✓ More control over chat appearance</p>
			</div>
			<div class="box">
				<hh3>Things to Consider</hh3>
				<p>✗ Not officially supported by Meta</p>
				<p>✗ Requires manual APK updates</p>
				<p>✗ Account restrictions may be possible when using modified apps</p>
				<p>✗ Backup methods may differ from official WhatsApp</p>
			</div>
		</div>
		<p>
			GB WhatsApp can provide additional features for users who want more flexibility, but it is important to
			understand how backups, updates, and third-party apps work before using it.
		</p>

		<hh2>Is GB WhatsApp Safe?</hh2>
		<p>
			Many people use GBWhatsApp because of features like advanced privacy controls, custom themes, and additional
			messaging tools. However, unlike the official WhatsApp app, GB WhatsApp is not distributed through Google
			Play and does not receive official support from Meta.
		</p>
		<p>To use GB WhatsApp more safely, consider these tips:</p>
		<ul>
			<li>Download APK files from trusted sources</li>
			<li>Keep your app updated to the latest available version</li>
			<li>Create regular backups before updating</li>
			<li>Avoid installing unknown modified APK files</li>
			<li>Check app permissions before use</li>
		</ul>

		<hh2>Best GB WhatsApp Alternatives in 2026</hh2>
		<p>
			If you are looking for more customization options or different features, there are several WhatsApp MODs
			that offer a similar experience to GB WhatsApp. Each version has its own design, features, and development
			style, so the best choice depends on what you are looking for.
		</p>
		<p>Here are some popular GB WhatsApp alternatives for Android:</p>

		<div class="alt-cards">
			<article class="alt-card">
				<h3>WhatsApp Plus</h3>
				<p>
					WhatsApp Plus is one of the most well-known WhatsApp MODs. It focuses on customization options,
					allowing users to change themes, colors, fonts, and other interface elements.
				</p>
			</article>
			<article class="alt-card">
				<h3>FM WhatsApp</h3>
				<p>
					FM WhatsApp is popular among users who want additional privacy settings and customization features.
					It includes options for controlling online visibility, chat appearance, and media sharing.
				</p>
			</article>
			<article class="alt-card">
				<h3>YOWhatsApp</h3>
				<p>
					YOWhatsApp provides a balance between design changes and extra messaging tools. It is known for its
					clean interface, customization options, and additional privacy controls.
				</p>
			</article>
			<article class="alt-card">
				<h3>JTWhatsApp</h3>
				<p>
					JTWhatsApp is another modified WhatsApp version that offers extra themes, privacy settings, and
					features similar to other WhatsApp MODs.
				</p>
			</article>
			<article class="alt-card">
				<h3>WhatsApp Aero</h3>
				<p>
					WhatsApp Aero is mainly focused on visual customization. It offers a modern interface, unique themes,
					and more design options compared with the standard WhatsApp app.
				</p>
			</article>
			<article class="alt-card">
				<h3>GB WhatsApp Pro</h3>
				<p>
					GB WhatsApp Pro is another variation based on the GB WhatsApp concept, offering additional features,
					privacy tools, and customization options.
				</p>
			</article>
			<article class="alt-card">
				<h3>MB WhatsApp</h3>
				<p>
					MB WhatsApp provides extra personalization features and messaging tools for users who want a
					different WhatsApp experience.
				</p>
			</article>
			<article class="alt-card">
				<h3>Fouad iOS WhatsApp</h3>
				<p>
					Fouad iOS WhatsApp brings an iPhone-style interface to Android devices, allowing users to enjoy an
					iOS-inspired WhatsApp design.
				</p>
			</article>
		</div>

		<hh2>FAQ</hh2>
		<FAQ :faqs="faqs" />
	</article>
</template>

<script>
import FAQ from '@/components/FAQ.vue'

export default {
	name: 'HomeArticleEn',
	components: { FAQ },
	data() {
		return {
			imgAndroid: require('@/assets/home/gbwhatsapp-android.webp'),
			imgPrivacy: require('@/assets/home/advanced-privacy.webp'),
			imgChat: require('@/assets/home/chat.webp'),
			homeOldVersions: [
				{ version: 'GB WhatsApp v18.70', release: '2026', status: 'Previous Stable Version' },
				{ version: 'GB WhatsApp v18.50', release: '2026', status: 'Popular Older Version' },
				{ version: 'GB WhatsApp v18.30', release: '2025', status: 'Stable Release' },
				{ version: 'GB WhatsApp v18.10', release: '2025', status: 'Older Release' },
				{ version: 'GB WhatsApp v17.85', release: '2025', status: 'Classic Stable Version' },
				{ version: 'GB WhatsApp v17.60', release: '2024', status: 'Legacy Version' },
				{ version: 'GB WhatsApp v17.30', release: '2024', status: 'Older Build' },
			],
			compareOfficial: [
				{
					feature: 'Custom Themes',
					gb: '✅ Supports custom themes and interface changes',
					official: '❌ Limited customization',
				},
				{
					feature: 'Hide Online Status',
					gb: '✅ Advanced privacy controls',
					official: 'Limited options',
				},
				{
					feature: 'Hide Typing & Recording Status',
					gb: '✅ Available',
					official: '❌ Not available',
				},
				{
					feature: 'Message Scheduling',
					gb: '✅ Supported',
					official: '❌ Not available',
				},
				{
					feature: 'Auto Reply',
					gb: '✅ Built-in feature',
					official: 'Available mainly in WhatsApp Business',
				},
				{
					feature: 'Status Downloader',
					gb: '✅ Built-in tool',
					official: '❌ Not available',
				},
				{
					feature: 'Larger File Sharing',
					gb: '✅ Supports expanded sharing options',
					official: 'Limited by official restrictions',
				},
				{
					feature: 'Chat Customization',
					gb: '✅ Fonts, colors, wallpapers, layouts',
					official: 'Basic options',
				},
				{
					feature: 'App Lock',
					gb: '✅ Available in many versions',
					official: 'Limited security options',
				},
				{
					feature: 'Official Updates',
					gb: '❌ Requires manual APK updates',
					official: '✅ Automatic Play Store updates',
				},
				{
					feature: 'Official Support',
					gb: '❌ Not supported by Meta',
					official: '✅ Supported by Meta',
				},
			],
			faqs: [
				{
					question: 'Is GB WhatsApp APK free to download?',
					answer: 'Yes, GB WhatsApp APK is available as a free download for Android users.',
				},
				{
					question: 'Can I install GB WhatsApp without root?',
					answer: 'Yes. GB WhatsApp can normally be installed on standard Android devices without root access.',
				},
				{
					question: 'Will I lose my chats when updating GB WhatsApp?',
					answer:
						'Creating a backup before updating is recommended to help protect your chats and media files.',
				},
				{
					question: 'What Android version supports GB WhatsApp?',
					answer: 'GB WhatsApp v18.80 supports Android 5.0 and newer versions.',
				},
				{
					question: "Why can't I install GB WhatsApp APK?",
					answer:
						'Installation problems are usually caused by insufficient storage, disabled APK permissions, or conflicts with an existing installation.',
				},
			],
		}
	},
}
</script>
